import { useEffect, useState } from 'react'

/**
 * Track whether the device is currently in a mobile state based on the user agent.
 *
 * Useful for features that aren't helpful/supported on mobile devices.
 *
 * @returns {boolean}  true  → device is in a mobile state
 */
const useIsMobileDevice = () => {
  const [isMobile, setIsMobile] = useState(false)

  useEffect(() => {
    const checkMobile = () => {
      const isDeviceMobile =
        /Mobi|Android|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
          navigator.userAgent,
        )
      setIsMobile(isDeviceMobile)
    }

    checkMobile()
  }, [])

  return isMobile
}

export default useIsMobileDevice
